{
  "SET_NEW_PASSWORD": {
    "TITLE": "הגדר סיסמה חדשה",
    "PASSWORD": {
      "LABEL": "סיסמה",
      "PLACEHOLDER": "סיסמה",
      "ERROR": "הסיסמה קצרה מדי"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "אמת סיסמה",
      "PLACEHOLDER": "אמת סיסמה",
      "ERROR": "סיסמאות לא תואמות"
    },
    "API": {
      "SUCCESS_MESSAGE": "שינתה את הסיסמה בהצלחה",
      "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
    },
    "CAPTCHA": {
      "ERROR": "פג תוקף האימות. נא לפתור שוב את ה-captcha."
    },
    "SUBMIT": "שלח"
  }
}
